import React from 'react'
import PageList from '../../components/PageListAPI'
import { deleteWorkerOne, getWorkerList } from '../../api/worker'
import { Link } from 'react-router-dom';
import { Button, Rating } from '@mui/material'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';

export default function WorkerList(props) {
  const can = useCan()
  const toLinkRating = React.forwardRef((props1, ref) => (<Link ref={ref} to='worker/rating' {...props1} />));
  return <div className='App-paper'>
    <PageList
      name='workerList'
      title='Список работников'
      columns={[
        { id: 'surname', name: 'Фамилия' },
        { id: 'name', name: 'Имя' },
        { id: 'patronymic', name: 'Отчество' },
        { id: 'position', name: 'Должность' },
        { id: 'star', name: 'Рейтинг', type: 'component', component: ({ obj }) => (<Rating defaultValue={0} precision={0.1} value={Number(obj.star)} readOnly />) },
      ]}
      createItem={can(SLUGS.CATALOG.WORKER.MANAGE)}
      deleteItem={can(SLUGS.CATALOG.WORKER.MANAGE)}
      headerLink={
        <Button component={toLinkRating} color="primary" >Рейтинг</Button>
      }
      loadAPI={{
        request: getWorkerList,
      }}
      deleteAPI={deleteWorkerOne}
      headerInit={{
        sortBy: 'surname',
        sortDirection: 'desc',
      }}
      {...props}
    />
  </div>
}